import { render, staticRenderFns } from "./bankretconfig.vue?vue&type=template&id=4ab691da&"
import script from "./bankretconfig.vue?vue&type=script&lang=js&"
export * from "./bankretconfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports